import { render, staticRenderFns } from "./_versions.vue?vue&type=template&id=da0c47ea"
import script from "./_versions.vue?vue&type=script&lang=js"
export * from "./_versions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports